import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { useLocation } from 'react-router-dom';
import { styled } from '@mui/material';
import TabLink from './components/TabLink/TabLink';
import HelperTooltip from '../../HelperTooltip/HelperTooltip';
import linksConfig from '../../../config/linking';

const Wrapper = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[400]}`,
  width: '100%',
}));

interface NavTabsProps {
  paths: { label: string; to: string; show: boolean }[];
}

export default function NavTabs(props: NavTabsProps) {
  const { paths } = props;
  const location = useLocation();

  const activeIndex = paths.findIndex(
    (path) => location.pathname.replace('/', '') === path.to
  );

  const isExistingPath = activeIndex !== -1;

  return (
    <Wrapper aria-label="nav wrapper" position="relative">
      <Tabs value={isExistingPath ? activeIndex : false} aria-label="nav tabs">
        {paths.map((path) => (
          <TabLink key={path.to} label={path.label} to={path.to} />
        ))}
      </Tabs>
      <HelperTooltip
        tooltipData={linksConfig.howToUse}
        sx={{ marginLeft: '12px', position: 'absolute', right: 0, top: '24px' }}
      />
    </Wrapper>
  );
}
